import axios from '../../helpers/axios-setup';

export const approveApplication = (id: number) => axios.put(`/staff/applications/approve/${id}`);
